import { render, staticRenderFns } from "./InterpretacionesPendientes.vue?vue&type=template&id=3191bcd8"
import script from "./InterpretacionesPendientes.vue?vue&type=script&lang=js"
export * from "./InterpretacionesPendientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports